import { Asterisk } from "lucide-react";

const ITEMS = [
  "50 researched target accounts",
  "Decision-makers identified",
  "Email · LinkedIn · Calling",
  "4-touch follow-up sequence",
  "Live proof run",
  "Simple pipeline tracker",
  "First 3 founders: $149",
];

const Marquee = () => (
  <section
    data-testid="marquee-strip"
    className="overflow-hidden border-y border-line bg-sand py-5"
  >
    <div className="marquee-track flex w-max items-center">
      {[0, 1].map((copy) => (
        <div key={copy} aria-hidden={copy === 1} className="flex items-center">
          {ITEMS.map((item) => (
            <span
              key={`${copy}-${item}`}
              className="flex items-center whitespace-nowrap pr-10 pl-10 font-mono text-xs font-medium uppercase tracking-[0.22em] text-smoke first:pl-0"
            >
              {item}
              <Asterisk className="ml-10 h-4 w-4 text-terra" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </section>
);

export default Marquee;
